import { useLayoutEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import { WeScreen } from '@/components/WeScreen/WeScreen'
import { AppRoutes } from '@/constants/appRoutes'
import { useAppDispatch } from '@/hooks/redux'
import { useRunReportGuard } from '@/pages/RunReport/guards/useRunReportGuard'
import {
  EReportType,
  ERunReportQueryParam,
  ERunReportStep,
  ESearchType,
} from '@/pages/RunReport/types'
import { setSearchType } from '@/store/api/RunReport/RunReport.slice'
import { parseEnumQueryParam } from '@/utils/parseEnumQueryParam'

export const StartSearch = () => {
  useRunReportGuard(ERunReportStep.StartSearch)
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const reportTypeFromUrl = parseEnumQueryParam(
    searchParams.get(ERunReportQueryParam.ReportType),
    EReportType,
  )
  const isAiOnly = reportTypeFromUrl === EReportType.AiReport

  useLayoutEffect(() => {
    if (isAiOnly && reportTypeFromUrl) {
      dispatch(setSearchType(ESearchType.Individual))
      navigate(
        `${AppRoutes.runReportSearchForm}?${ERunReportQueryParam.ReportType}=${reportTypeFromUrl}`,
        { replace: true },
      )
    }
  }, [isAiOnly, reportTypeFromUrl, dispatch, navigate])

  if (isAiOnly) return null

  const handlePick = (type: ESearchType) => {
    dispatch(setSearchType(type))

    const reportType = searchParams.get(ERunReportQueryParam.ReportType)
    const target = reportType
      ? `${AppRoutes.runReportSearchForm}?${ERunReportQueryParam.ReportType}=${reportType}`
      : AppRoutes.runReportSearchForm

    navigate(target)
  }

  return (
    <WeScreen
      useNextButton={false}
      useSkipButton={false}
      onClickBack={() => navigate(AppRoutes.dashboard)}
      hideHeaderOnMobile
    >
      <div className="flex flex-1 flex-col items-center justify-center gap-6 p-6">
        <h2 className="text-[28px] font-medium text-neutralColor text-center">
          {t('dashboard.runReport.startSearch.kindTitle')}
        </h2>
        <div className="flex flex-wrap items-center justify-center gap-3">
          <Button
            variant="secondary"
            onClick={() => handlePick(ESearchType.Company)}
          >
            {t('dashboard.runReport.startSearch.companyButton')}
          </Button>
          <Button
            variant="secondary"
            onClick={() => handlePick(ESearchType.Individual)}
          >
            {t('dashboard.runReport.startSearch.individualButton')}
          </Button>
        </div>
      </div>
    </WeScreen>
  )
}
